import { render } from "./MessageModal.vue?vue&type=template&id=72891873&scoped=true&ts=true"
import script from "./MessageModal.vue?vue&type=script&lang=ts"
export * from "./MessageModal.vue?vue&type=script&lang=ts"

import "./MessageModal.vue?vue&type=style&index=0&id=72891873&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72891873"]])

export default __exports__